
































import { Component, Vue, Watch } from "vue-property-decorator";
import homeTop from "./homeTop.vue";
// import { versionInfo } from "@/req/home";
// import updateModal from "../Home/updateModal.vue";
import { routeList } from "@/components/giftBoxRoute";
@Component({
  components: {
    homeTop,
    // updateModal
  },
})
export default class Home extends Vue {
  public activeMenu = "";
  public showToTop = false;

  public routerState = true;
  public showList = true;
  public showNav = true;
  public breadList = [];
  public routeList = routeList;
  public backTopShow = false;
  @Watch("$route", { immediate: true })
  public change(item) {
    const blen = this.routeList.some((items) => {
      return this.$route.path == items.path;
    });
    this.backTopShow = blen;
    // this.path = item.path
    if (item.meta.showList == 0) {
      this.showList = false;
    } else {
      this.showList = true;
    }
    this.breadList = [];
    if (item.meta.showNav == false) {
      this.breadList = item.meta.menu;
      this.showNav = false;
    } else {
      this.showNav = true;
    }
  }
  public created() {
    const blen = this.routeList.some((items) => {
      return this.$route.path == items.path;
    });
    this.backTopShow = blen;
    if ((this as any).$route.meta.showList == 0) {
      this.showList = false;
    } else {
      this.showList = true;
    }
  }
  public mounted() {
    // 监听滚动条
    window.addEventListener("scroll", this.handleScroll, true);
    if (Number(localStorage.getItem("update"))) {
      // this.checkUpdate();
    }
  }
  public destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  // 检查更新
  // public async checkUpdate() {
  //   const res = await versionInfo({
  //     app_version: (window as any).localStorage.getItem("appv"),
  //   });
  //   // app_status 1 为强更  2 为提醒更新
  //   if (res.code == 200 && res.data.app_status > 0) {
  //     (window as any).firstSetup = 0;
  //     if (res.data.app_status == 1) {
  //       localStorage.setItem("update", "1");
  //     } else {
  //       localStorage.setItem("update", "0");
  //     }
  //     const $updateModal: any = this.$refs.updateModal;
  //     $updateModal.show(res.data);
  //   }
  // }
  public handleScroll() {
    // let windowScrollY = window.scrollY;
    const windowScrollY =
      window.pageYOffset || // 用于FF
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (windowScrollY > 500) {
      // 当滚动大于一屏高度时的操作
      this.showToTop = true;
      //   console.log(11);
    } else {
      // 当滚动小于于一屏高度时的操作
      this.showToTop = false;
      //   console.log(22);
    }
  }
  public toTop() {
    // if (document.body.scrollTop > 0) {
    //   setTimeout(() => {
    //     document.body.scrollTop = document.body.scrollTop - 10;
    //     this.toTop();
    //   });
    // }
    if (document.documentElement.scrollTop > 0) {
      setTimeout(() => {
        document.documentElement.scrollTop =
          document.documentElement.scrollTop - 50;
        this.toTop();
      });
    }
  }
}
